import React, { useState } from "react";
import List from "./inc/List";
import Add from "./inc/Add";
import { Button, Container, Snackbar } from "@mui/material";

function CrudTest() {
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [refreshList, setRefreshList] = useState(false);

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
  };

  const handleComicAdded = () => {
    setSnackbarMessage("Comic added successfully!");
    setSnackbarOpen(true);
    setRefreshList(!refreshList);
  };

  const handleComicUpdated = () => {
    setRefreshList(!refreshList);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container>
      <h1>Comics CRUD</h1>
      <Button variant="contained" color="primary" onClick={handleOpenAddDialog}>
        Add Comic
      </Button>
      <List refresh={refreshList} onComicUpdated={handleComicUpdated} />
      <Add
        open={openAddDialog}
        onClose={handleCloseAddDialog}
        onComicAdded={handleComicAdded}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
    </Container>
  );
}

export default CrudTest;
